import React, { useState } from 'react';
import { Modal } from 'antd';
import { dateFormat, lineBreak } from '../../../module/ConstantFunctions';
import { Link } from 'react-router-dom';
import pause from '../../../Assets/Images/pause.png';
import Spinner from '../../../Constants/Spinner';
import HashIcon from '../../../Assets/Icons/HashIcon';
import CalenderIcon from '../../../Assets/Icons/CalenderIcon';
import BookIcon from '../../../Assets/Icons/BookIcon';
import PlayIcon from '../../../Assets/Icons/PlayIcon';
import DraftIcon from '../../../Assets/Icons/DraftIcon';
import EditIcon from '../../../Assets/Icons/EditIcon';
import DeleteIcon from '../../../Assets/Icons/DeleteIcon';
import PublishIcon from '../../../Assets/Icons/PublishIcon';
import { assetURL } from '../../../api/utils';
import { RichTextPreviewer } from '../../../core/components/RichTextPreviewer';

function DraftPostModal({
  isModalOpen,
  handleOk,
  handleCancel,
  data,
  statusFunction,
  deleteFunction,
  status,
  actionButtons,
}) {
  const [played, setPlayed] = useState(false);

  function playAudio() {
    if (data.recitation_audio || data.recitation_audio_url) {
      setPlayed(true);
      var x = document.getElementById('myAudio');
      x.play();
    }
  }

  function pauseAudio() {
    if (data.recitation_audio || data.recitation_audio_url) {
      setPlayed(false);
      var x = document.getElementById('myAudio');
      x.pause();
    }
  }
  const [publishLoader, setPublishLoader] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);

  if (!data) return null;

  return (
    <Modal
      title={false}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={false}
      className="max-w-[920px] w-full"
      width={'100%'}>
      <div className="postDetails flex sm:w-[60%] w-full justify-between">
        <div className="flex items-center justify-between w-[48%] bg-[#eef2f0] rounded-[12px] py-[8px] pr-[8px] pl-[16px]">
          <div className="flex items-center">
            <div>
              <HashIcon />
            </div>
            <div className="ml-[16px]">
              <p className="text-xs text-[#7b867c]">Post Number</p>
              <p dir="ltr" className="urduText text-[25px] leading-[19px] font-medium" style={{ textAlign: 'left' }}>
                {data.post_number}
              </p>
            </div>
          </div>

          {/* <div className="flex items-center justify-center volume bg-[#2a9134] text-sm text-white  rounded-full w-[32px] h-[32px]">
            V1
          </div> */}
        </div>
        <div className="flex items-center w-[48%] bg-[#eef2f0] rounded-[12px] py-[11px] pr-[8px] pl-[16px]">
          <div>
            <CalenderIcon />
          </div>
          <div className="ml-[16px]">
            <p className="text-xs text-[#7b867c]">Post Date</p>
            <p className="font-medium">{dateFormat(data.date_post)}</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-start w-full mt-4 bg-[#eef2f0] rounded-[12px] py-[8px] pr-[8px] pl-[16px]">
        <BookIcon />
        <p dir="ltr" className="urduText font-bold ml-[8px] " style={{ textAlign: 'left' }}>
          {data.book[0]?.bookName}
        </p>
      </div>
      <div className="bg-[#eef2f0] py-[8px] pr-[8px] pl-[16px] mt-4 rounded-[12px]">
        <p className='font-["Poppins-ExtraBold"]'>Post Text</p>
      </div>
      <div className="mt-6">
        <RichTextPreviewer content={data.content} />
      </div>
      {/* <p dir="ltr" className="urduText font-bold text-[#7b867c] text-xl mt-[32px]">
        بوداود (٤/٣٢٥) و ترمذى (٥/٤٩٠) و نگا: صحیح ترمذى (٣/١٥١).
      </p> */}
      <p dir="ltr" className="urduText font-bold text-[#0e3a1e] text-xl mt-6">
        {data.categories.map(c => c.category_name).join(' > ')}
      </p>
      <div className="bg-[#eef2f0] py-[8px] pr-[8px] pl-[16px] mt-4 mb-6 rounded-[12px]">
        <p className='font-["Poppins-ExtraBold"]'>Recitation</p>
      </div>
      <audio id="myAudio">
        <source
          src={data.recitation_audio_url ? data.recitation_audio_url : `${assetURL}${data.recitation_audio}`}
          type="audio/mp3"
        />
        <source
          src={data.recitation_audio_url ? data.recitation_audio_url : `${assetURL}${data.recitation_audio}`}
          type="audio/mp3"
        />
        Your browser does not support the audio element.
      </audio>
      <div className="flex items-center">
        {played ? (
          <button
            className="bg-[#2a9134] w-[40px] h-[40px] rounded-full flex items-center justify-center"
            onClick={pauseAudio}>
            <img className="h-[30%]" src={pause} />
          </button>
        ) : (
          <button
            className="bg-[#2a9134] w-[40px] h-[40px] rounded-full flex items-center justify-center"
            onClick={playAudio}>
            <PlayIcon />
          </button>
        )}
        <p className="mx-[8px] font-semibold  text-text-ellipsis w-[calc(100%-40px)]">{data.recitation_audio}</p>
      </div>
      {actionButtons ? (
        <div>
          <div className="flex items-center justify-center">
            <div className="tools flex items-center justify-between max-w-[500px] w-full">
              {status === 'draft' ? (
                <button
                  disabled={publishLoader}
                  className="relative text-white bg-[#2a9134] flex items-center justify-center h-[48px] sm:w-[48%] sm:mt-0 mt-6 w-full px-4 rounded-xl transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105"
                  onClick={() => statusFunction(data, 'post', setPublishLoader)}>
                  {publishLoader ? <Spinner /> : null}

                  <span
                    className={
                      publishLoader ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'
                    }>
                    <PublishIcon className="mr-[6px]" />
                    Publish to Live Site
                  </span>
                </button>
              ) : status === 'post' ? (
                <button
                  disabled={publishLoader}
                  className="relative text-white bg-black flex items-center justify-center h-[48px] w-[48%] px-4 rounded-xl"
                  onClick={() => statusFunction(data, 'draft')}>
                  {publishLoader ? <Spinner /> : null}
                  <span
                    className={
                      publishLoader ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'
                    }>
                    <DraftIcon className="mr-[6px]" />
                    Move to Drafts
                  </span>
                </button>
              ) : null}
              <div className="flex items-center justify-between w-[48%] py-6 ">
                <Link className="w-[48%]" to={`/edit-post?id=${data._id}`}>
                  <button className="w-full text-white bg-[#EEF2F0]  flex items-center justify-center h-[48px] px-4 rounded-xl">
                    <EditIcon width={26} height={24} fill="#000" />
                  </button>
                </Link>
                <button
                  disabled={deleteLoader}
                  className="relative w-[48%] text-white bg-[#ca3030]  flex items-center justify-center h-[48px] px-4 rounded-xl"
                  onClick={() => deleteFunction(data._id, setDeleteLoader)}>
                  {deleteLoader ? <Spinner /> : null}
                  <span
                    className={
                      deleteLoader ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'
                    }>
                    <DeleteIcon pathProp={{ fill: '#fff' }} />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </Modal>
  );
}

export default DraftPostModal;
